import * as Sentry from "@sentry/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { enablePatches } from "immer";
import { useEffect } from "react";
import React from "react";
import ReactDOM from "react-dom/client";
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from "react-router-dom";

import App from "./App";
import "./index.css";

enablePatches();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <React.StrictMode>
        <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
            <App />
            <SpeedInsights />
        </Sentry.ErrorBoundary>
    </React.StrictMode>
);

Sentry.init({
    dsn: "https://97ce1044ff6d2e4a1d3996fb1200a672@o4506627092250624.ingest.us.sentry.io/4507990821961728",
    integrations: [
        // See docs for support of different versions of variation of react router
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
        Sentry.replayIntegration(),
    ],
    enabled: import.meta.env.PROD,
    environment: import.meta.env.MODE,
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        "localhost",
        /^https:\/\/cms\.fantasychess\.app/,
        /^https:\/\/fchess-cms-staging\.fly\.dev/,
    ],
    // Set profilesSampleRate to 1.0 to profile every transaction.
    // Since profilesSampleRate is relative to tracesSampleRate,
    // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
    // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
    // results in 25% of transactions being profiled (0.5*0.5=0.25)
    profilesSampleRate: 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // We just run with debug enabled, since we're not exposing the CMS to end users anyway.
    debug: true,
});
